import { creatorbase } from '@round/api';
import { useCreatorbaseTimeSeries } from '@round/creatorbase-helpers/api-hooks';

type Params = Pick<creatorbase.TimeSeriesRequestParams, 'start_date' | 'end_date'> & {
    songId: number | null | undefined;
};

export function useCreations({ start_date, end_date, songId }: Params) {
    return useCreatorbaseTimeSeries(
        {
            type: 'song',
            fields: ['tiktok_daily_change', 'tiktok_daily_totals', 'instagram_daily_change', 'instagram_daily_totals'],
            ids: songId ? [songId] : [],
            start_date,
            end_date,
        },
        {
            enabled: !!songId,
            select: (data) => (songId ? data[songId] : null),
        }
    );
}
